import React from 'react'
import { EXCLUDED_BRANDS } from '../../utils/constants'
import { convertImagePathToFitImageSize } from 'client/fragments/productDetailsFragmentInfo/selectors/gallery'
import { descriptionTruncate } from 'client/common/description'
import { getProductAvailability } from 'client/common/selectors/product'

export const ProductSchema = props => {
  const {
    brands,
    image,
    name,
    description,
    fullPriceProps,
    sku,
    gtin13,
    url,
    availability,
    variants,
    variantGroupId,
    attrSchemaMap = {}
  } = props
  const { price } = fullPriceProps
  const brand = brands?.find(b => !EXCLUDED_BRANDS.includes(b?.name))
  const hasVariants = variantGroupId && !!Object.keys(attrSchemaMap).length && !!variants?.length
  // DO NOT LEAVE COMMENTS INSIDE JSON!!!
  const json = {
    '@context': 'https://schema.org',
    '@type': hasVariants ? 'ProductGroup' : 'Product',
    '@id': url,
    ...(!!hasVariants && { productGroupID: variantGroupId }),
    name,
    image: convertImagePathToFitImageSize(image),
    sku,
    gtin13,
    description: descriptionTruncate(description, 290),
    ...(!!brand?.length && {
      brand: {
        '@type': 'Brand',
        name: brand.name
      }
    }),
    ...(hasVariants && {
      variesBy: variants.map(it => attrSchemaMap[it.code]).filter(it => !!it),
      hasVariant: getVariants(variants, attrSchemaMap)
    }),
    offers: {
      '@type': 'Offer',
      priceCurrency: 'EUR',
      url,
      price,
      availability
    }
  }
  return (
    <script
      style={{ display: 'none' }}
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(json) }}
    />
  )
}

/*
 * if we have more than 1 attribute, google requires pass all attr in 1 project, so here
 * we accumulate combinations based on product sku, so in result we will have smth like
 * {
 *  '@type': 'Product',
 *  ...
 *  color:'white',
 *  size:'big',
 *  material:'cotton'
 * }
 * */
export function getVariants(variants, attrSchemaMap) {
  const obj = {}

  const validVariants = variants.filter(variant => !!attrSchemaMap[variant?.code])
  validVariants.forEach(variant => {
    const entries = variant.entries
    const attr = attrSchemaMap[variant?.code]?.replace('https://schema.org/', '')

    entries.forEach(it => {
      const sku = it.product?.code
      if (!obj[sku]) {
        obj[sku] = {
          '@type': 'Product',
          sku,
          name: it.product?.name,
          gtin13: it?.product?.ean,
          image: convertImagePathToFitImageSize(it?.product?.image),
          description: descriptionTruncate(it?.product?.description, 290),
          offers: {
            '@type': 'Offer',
            url: it?.product?.url,
            priceCurrency: 'EUR',
            price: it?.product?.price,
            availability: getProductAvailability(it?.product?.itemAvailability)
          },
          productAttrCounter: 0
        }
      }

      obj[sku][attr] = it?.name
      obj[sku].productAttrCounter = ++obj[sku].productAttrCounter
    })
  })

  // we need product only with all data, because in other case it's invalid
  return Object.values(obj).filter(it => {
    const isValid = it.productAttrCounter === validVariants.length
    delete it.productAttrCounter
    return isValid
  })
}
